/**
 * Pick a client's services from the company's list (Bill, 2026-10-23: a prebuilt list for consistency,
 * admins add more in Settings > TechHub > Services). Retired services stay ticked on clients that
 * already have them, but can't be newly picked.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type ChService } from "../../lib/api";

export function ServicePicker({ company, value, onChange, keep = [] }: { company: string; value: string[]; onChange: (ids: string[]) => void; keep?: string[] }) {
  const [list, setList] = useState<ChService[] | null>(null);
  const [manage, setManage] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    setList(null); setErr(null);
    api.chServices(company).then((r) => { if (live) { setList(r.services); setManage(r.can_manage); } }, (e: Error) => live && setErr(e.message));
    return () => { live = false; };
  }, [company]);
  if (err) return <div className="help">{err}</div>;
  if (!list) return <div className="help">Loading services…</div>;
  const shown = list.filter((s) => s.active || value.includes(s.id) || keep.includes(s.id));
  const flip = (id: string) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div>
      <div className="svc-pick" role="group" aria-label="Services">
        {shown.map((s) => {
          const on = value.includes(s.id);
          return (
            <button key={s.id} type="button" className={on ? "on" : ""} aria-pressed={on} onClick={() => flip(s.id)} disabled={!s.active && !on}
              title={s.active ? "" : "Retired: stays on this client, can't be picked again"}>
              <span className="tick" aria-hidden="true">{on ? "\u2713" : "+"}</span>{s.name}{!s.active && <small> (retired)</small>}
            </button>
          );
        })}
        {!shown.length && <span className="help">No services in the list yet.</span>}
      </div>
      <div className="help">{manage ? <>Missing one? <Link to={`/settings/services?co=${company}`}>Add it to the services list</Link>.</> : "Missing one? Ask a company admin to add it to the services list."}</div>
    </div>
  );
}
